import { createActionTypeModel } from "@/store/global/action-model";
export * from './users/types';
export * from './general/types';
export * from './invoice-projects/types';
export * from './booking/types';
export * from './accounting/types';
export * from './billing/types';
export * from './label/types';
export * from './custom_texts/types';
export * from './notices/types';
export * from './language/types';
export * from './sharing/types';
export * from './promotion/types'
export * from './externalusers/types'
export * from './task/types'
export const TaskTemplate = createActionTypeModel("TaskTemplate");
export const TaskTemplateGroup = createActionTypeModel("TaskTemplateGroup");
export const TaskTemplateGroupItems = createActionTypeModel("TaskTemplateGroupItems");
export const TaskSettingsData = createActionTypeModel("TaskSettingsData");